import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import styled from 'styled-components';
import {Switch} from 'web-components';
import UpdateCompanyMutation from '../../mutations/update_company_mutation.modern';
import Util from '../../forecast-app/shared/util/util';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';

export const InvoicingStyle = styled.div`
	padding-bottom: 33px;
`;
export const SwitchLabel = styled.div`
	font-size: 13px;
	margin: 0 0 0 8px;
`;
export const SwitchWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	margin: 16px 0 0 0;
	align-items: center;
`;

export const Invoicing = ({company}) => {
	const intl = useIntl();

	const changeCanUnlinkInvoice = arg => {
		const onSuccess = () => {
			createToast({
				duration: 5000,
				message: intl.formatMessage({id: 'settings_finance.invoicing.toast_text'}),
			});
		};

		Util.CommitMutation(
			UpdateCompanyMutation,
			{
				userCanUnlinkInvoice: !arg,
			},
			onSuccess
		);
	};

	return (
		<InvoicingStyle data-userpilot={'invoicing-section'}>
			<p className="description">
				<FormattedMessage id="settings_finance.invoicing_description" />
			</p>
			<SwitchWrapper>
				<Switch checked={company.integrations.userCanUnlinkInvoice} onChange={changeCanUnlinkInvoice} />
				<SwitchLabel>
					<FormattedMessage id="common.enable" />
				</SwitchLabel>
			</SwitchWrapper>
		</InvoicingStyle>
	);
};
